import React, { FunctionComponent, ReactNode } from "react";
import classnames from "classnames";
import {
  PiggyBankIcon,
  CheckShieldIcon,
  DrugsIcon,
  PharmacyIcon,
} from "@cmsgov/ds-medicare-gov";
import { v1 as uuidv1 } from "uuid";

interface SubSectionProps {
  icon: SectionIconTypes;
  children: ReactNode;
  heading: string;
  headingId?: string;
  hasBorder?: false;
  name?: string;
}

export enum SectionIconTypes {
  PiggyBankIcon,
  CheckShieldIcon,
  DrugsIcon,
  PharmacyIcon,
}

export const checkShieldIconTestId = "check-with-shield-icon--duotone";
export const drugsIconTestId = "drugs-icon";
export const pharamcyIconTestId = "pharmacy-icon";
export const piggyBankIconTestId = "piggy-bank-icon";

const SubSection: FunctionComponent<SubSectionProps> = ({
  children,
  hasBorder = true,
  heading,
  headingId = `sub-section-heading-${uuidv1()}`,
  icon,
  name,
}) => {
  const baseClassName = "mct-c-sub-section";

  const iconDictionary = {
    [SectionIconTypes.CheckShieldIcon]: (className: string) => (
      <CheckShieldIcon
        className={className}
        data-testid={checkShieldIconTestId}
      />
    ),
    [SectionIconTypes.DrugsIcon]: (className: string) => (
      <DrugsIcon className={className} data-testid={drugsIconTestId} />
    ),
    [SectionIconTypes.PharmacyIcon]: (className: string) => (
      <PharmacyIcon className={className} data-testid={pharamcyIconTestId} />
    ),
    [SectionIconTypes.PiggyBankIcon]: (className: string) => (
      <PiggyBankIcon className={className} data-testid={piggyBankIconTestId} />
    ),
  };
  return (
    <section
      className={classnames(baseClassName, {
        [`${baseClassName}--no-border`]: !hasBorder,
        [`${baseClassName}__${name}`]: name,
      })}
    >
      <div
        className={`${baseClassName}__header ds-u-display--flex ds-u-align-items--center`}
      >
        {iconDictionary[icon] &&
          iconDictionary[icon](
            `${baseClassName}__icon ds-u-margin-right--2 mct-hide-print`
          )}
        <h2 className="ds-u-margin-top--0 ds-text-heading--xl" id={headingId}>
          {heading}
        </h2>
      </div>
      <div className={`${baseClassName}__body ds-u-margin-top--2`}>
        {children}
      </div>
      <hr className={`${baseClassName}__print-divider`} />
    </section>
  );
};

export default SubSection;
